import { render, staticRenderFns } from "./KcFooter.vue?vue&type=template&id=2679557e&scoped=true"
import script from "./KcFooter.vue?vue&type=script&lang=js"
export * from "./KcFooter.vue?vue&type=script&lang=js"
import style0 from "./KcFooter.vue?vue&type=style&index=0&id=2679557e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679557e",
  null
  
)

export default component.exports